<template>
  <v-dialog persistent v-model="flag" max-width="600">
    <v-card @click:outside="closeDialog()" class="c-confirmation text-sm" style="">
      <div class="d-flex justify-content-start text-lg mb-2">
       <b>{{ title }}</b>
      </div>
      <div class="d-flex justify-content-start mb-4">
        {{ description }}
      </div>
      <div class="d-flex justify-content-end mb-2">
        <div role="button" @click="closeDialog()" class="btn btn-sm btn-outline-primary mr-2" :class="cancelClass">{{ cancelText }}</div>
        <div v-show="contradictText !== ''" role="button" @click="contradict()" class="btn btn-sm btn-danger mr-2">{{ contradictText }}</div>
        <div role="button" @click="confirmation()" class="btn btn-sm btn-primary" :class="confirmationClass">{{ confirmationText }}</div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    flag: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    contradictText: {
      type: String,
      default: ''
    },
    confirmationText: {
      type: String,
      default: 'Yes'
    },
    confirmationClass: {
      type: String,
      default: ''
    },
    cancelClass: {
      type: String,
      default: ''
    }
  },
  methods: {
    closeDialog () {
      this.$emit('close-dialog')
    },
    confirmation () {
      this.$emit('confirm')
    },
    contradict () {
      this.$emit('contradict')
    }
  }
}
</script>

<style lang="scss">
.c-confirmation {
  font-size: 1rem;
  color: #3F3F3F !important;
  font-family: 'Lato', sans-serif !important;
  padding: 1.5rem 2rem;
  // .c-btn-yes {
  //   border-radius: 5px;
  //   padding: 0.375rem 1.5rem;
  //   color: white;
  //   background: #2F80ED;
  //   border: 1px solid #2F80ED;
  // }
  // .c-btn-cancel {
  //   border-radius: 5px;
  //   padding: 0.375rem 1rem;
  //   color: white;
  //   background: #BDBDBD;
  //   border: 1px solid #BDBDBD;
  // }
  // .c-btn-danger {
  //   border-radius: 5px;
  //   padding: 0.375rem 1rem;
  //   color: white;
  //   background: #D84F4F;
  //   border: 1px solid #D84F4F;
  // }
}
</style>
